import { useFormik } from "formik";
import { useCallback, useEffect, useRef, useState } from "react";
import { Alert, Form } from "react-bootstrap";
import { TagsInput } from "react-tag-input-component";
import ConfirmWithLoader from "../../../../../Components/Modals/ConfirmWithLoader";

/*value = {

  "emails_notaria": ["alberto.huacho@gmail.com"],
  "firmantes_firma_virtual": [
    {
      "firmante": {
        "codigo": "aa1610c5-3317-4ea6-bdb2-bdd0f7998c57",
        "nombre": "Mario Paredes"
      },
      "incluido": true
    },
    {
      "firmante": {
        "codigo": "bd40d6c2-bb78-4176-a86c-c8bde91b375b",
        "nombre": "Eduarda Moreyra"
      },
      "incluido": true
    },
    {
      "firmante": {
        "codigo": "2b813c32-0c3e-4626-a2d8-e736a05ecd8d",
        "nombre": "Fernando Ferreyra"
      },
      "incluido": false
    }
  ],
  "firmantes_firma_fisica": [
    {
      "firmante": {
        "codigo": "aa1610c5-3317-4ea6-bdb2-bdd0f7998c57",
        "nombre": "Mario Paredes"
      },
      "incluido": false
    },
    {
      "firmante": {
        "codigo": "bd40d6c2-bb78-4176-a86c-c8bde91b375b",
        "nombre": "Eduarda Moreyra"
      },
      "incluido": true
    },
    {
      "firmante": {
        "codigo": "2b813c32-0c3e-4626-a2d8-e736a05ecd8d",
        "nombre": "Fernando Ferreyra"
      },
      "incluido": true
    }
  ],
  "malls_configuracion": [
    {
      "emails_to_send_carta": ["alberto.huacho@gmail.com", "consultorexterno@voxiva.ai"],
      "nombre_to_carta": "Alberto Huacho",
      "id_mall": 2,
      "codigo": "AQP",
      "nombre": "Arequipa"
    },
    {
      "emails_to_send_carta": ["alberto.huacho@gmail.com", "consultorexterno@voxiva.ai"],
      "nombre_to_carta": "Alberto Huacho",
      "id_mall": 3,
      "codigo": "CIX",
      "nombre": "Chiclayo"
    },
    {
      "emails_to_send_carta": ["alberto.huacho@gmail.com", "consultorexterno@voxiva.ai"],
      "nombre_to_carta": "Alberto Huacho",
      "id_mall": 5,
      "codigo": "IQT",
      "nombre": "Iquitos"
    },
    {
      "emails_to_send_carta": [],
      "nombre_to_carta": null,
      "id_mall": 4,
      "codigo": "SJL",
      "nombre": "San Juan de Lurigancho"
    },
    {
      "emails_to_send_carta": [],
      "nombre_to_carta": null,
      "id_mall": 1,
      "codigo": "ASA",
      "nombre": "Santa Anita"
    }
  ]
}*/

/**Default Structure Prop Value
 {
    "emails_notaria": [],
    "firmantes_firma_virtual": [
      {
        "firmante": {
          "codigo": "",
          "nombre": "Mario Paredes"
        },
        "incluido": false
      },
      {
        "firmante": {
          "codigo": "",
          "nombre": "Eduarda Moreyra"
        },
        "incluido": false
      },
      {
        "firmante": {
          "codigo": "",
          "nombre": "Fernando Ferreyra"
        },
        "incluido": false
      }
    ],
    "firmantes_firma_fisica": [
      {
        "firmante": {
          "codigo": "",
          "nombre": "Mario Paredes"
        },
        "incluido": false
      },
      {
        "firmante": {
          "codigo": "",
          "nombre": "Eduarda Moreyra"
        },
        "incluido": false
      },
      {
        "firmante": {
          "codigo": "",
          "nombre": "Fernando Ferreyra"
        },
        "incluido": false
      }
    ],
    "malls_configuracion": [
      {
        "emails_to_send_carta": [],
        "nombre_to_carta": null,
        "id_mall": 0,
        "codigo": "",
        "nombre": ""
      }
    ]
  }
 
*/

export default function ConfigurationGenerationCartaNotarialModal({
  showModal = false,
  setShowModal,
  title,
  onConfirm,
  isFinishSave = false,
  setIsFinishSave,
  messageError,
  onClose,
  value = null
}) {
  const [isLoadingSave, setIsLoadingSave] = useState(true);
  const [isInitModal, setIsInitModal] = useState(true);
  const formValuesRef = useRef();

  const validateForm = (values) => {
    const errors = [];
    const checkedCountVirtual = values.checksSignedVirtual.filter((checkbox) => checkbox.incluido).length;
    const checkedCountFisical = values.checksSignedFisical.filter((checkbox) => checkbox.incluido).length;

    if (!values.emailNotariaList || values.emailNotariaList.length === 0) {
      errors.push({ field: 'Notaria - Correo Destinatario', message: 'Debe ingresar al menos un correo' });
    }

    if (checkedCountVirtual < 2) {
      errors.push({ field: 'Firma Virtual', message: 'Ha marcado menos de dos checks o no ha marcado ningun check. Debe marcar exactamente dos checks' });
    }
    if (checkedCountVirtual > 2) {
      errors.push({ field: 'Firma Virtual', message: 'Ha marcado mas de dos checks. Debe marcar exactamente dos checks' });
    }

    if (checkedCountFisical < 2) {
      errors.push({ field: 'Firma Fisica', message: 'Ha marcado menos de dos checks o no ha marcado ningun check. Debe marcar exactamente dos checks' });
    }
    if (checkedCountFisical > 2) {
      errors.push({ field: 'Firma Fisica', message: 'Ha marcado mas de dos checks. Debe marcar exactamente dos checks' });
    }

    values.groupBcp.forEach((item) => {
      if (!item.emails_to_send_carta || item.emails_to_send_carta.length === 0) {
        errors.push({ field: `BCP ${item.nombre} - Correo destinatario`, message: 'Debe ingresar al menos un correo' });
      }
      if (!item.nombre_to_carta) {
        errors.push({ field: `BCP ${item.nombre} - Nombre del Firmante`, message: 'Debe ingresar el nombre del firmante' });
      }
    });
    return errors;
  };

  const formik = useFormik({
    initialValues: {
      emailNotariaList: value?.emails_notaria ?? [],
      checksSignedVirtual: value?.firmantes_firma_virtual ?? [],
      checksSignedFisical: value?.firmantes_firma_fisica ?? [],
      groupBcp: value?.malls_configuracion ?? []
    },

    enableReinitialize: true,
    onSubmit: (values) => {
      setIsLoadingSave(true);
      setIsFinishSave(false);
      formValuesRef.current = values;
    }
  })

  const transformData = (values) => {
    return {
      email_notaria: values.emailNotariaList,
      firmantes_firma_virtual: values.checksSignedVirtual.map((item) => ({ codigo: item.firmante.codigo, incluido: item.incluido })),
      firmantes_firma_fisica: values.checksSignedFisical.map((item) => ({ codigo: item.firmante.codigo, incluido: item.incluido })),
      datos_mall_provincia: values.groupBcp.map((item) => {
        return {
          codigo_mall: item.codigo,
          email: item.emails_to_send_carta,
          nombre: item.nombre_to_carta
        }
      })
    }
  }

  useEffect(() => {
    if (isInitModal && formik.values && value) {
      setIsInitModal(false);
      setIsLoadingSave(false);
    }
  }, [formik, isInitModal, value])

  useEffect(() => {
    if (isFinishSave) {
      setIsLoadingSave(false);
    }
  }, [isFinishSave])

  useEffect(() => {
    const formValues = formValuesRef.current;
    if (!isInitModal && isLoadingSave && !isFinishSave) {
      const errors = validateForm(formValues);
      if (errors.length === 0) {
        onConfirm && onConfirm(transformData(formValues));
      } else {
        formik.setErrors(errors);
        setIsLoadingSave(false);
      }
    }
  }, [formik, isFinishSave, isInitModal, isLoadingSave, onConfirm])


  const handleClose = useCallback(() => {
    formik.resetForm();
    setIsInitModal(true);
    setIsFinishSave(false);
    setIsLoadingSave(true);
    onClose && onClose();
  }, [formik, setIsFinishSave, onClose])

  const validationEmail = (event) => {
    const regex = /^[a-zA-Z0-9.]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]+$/;
    return regex.test(event)
  }

  return (
    <ConfirmWithLoader
      showModal={showModal}
      setShowModal={setShowModal}
      title={title}
      isLoading={isLoadingSave}
      isFinish={isFinishSave}
      onConfirm={formik.handleSubmit}
      hideContentInLoading={false}
      hideActionAfterConfirm={false}
      size={"xl"}
      onClose={handleClose}
      scrollToHeader={!isLoadingSave}
      textButton={"Guardar"}
      textButtonCancel={"Cerrar"}
    >
      {!isLoadingSave && isFinishSave && (
        messageError ? (
          <Alert key='error' variant='primary'>
            <b>Error</b>: {messageError}
          </Alert>
        ) : (
          <Alert key='info' variant='success'>
            <b>Configuración guardada</b>: La Configuración para generar las <b><u>Cartas Notariales</u></b> se ha guardado exitosamente.
          </Alert>
        )
      )}
      {formik.errors.length > 0 && (
        <Alert key='warning' variant='warning' className="mb-7">
          <span className="fs-5">
            <b>Advertencia!</b>: Se encontraron errores en la validación.
          </span>
          <ul className="list-group border mt-3">
            {formik.errors.map((item, index) => (
              <li key={index} className="list-group-item d-flex align-items-center">
                <i className="fi fi-rr-triangle-warning me-3 text-warning"></i>
                <b>{item.field}:&nbsp;</b> {item.message}
              </li>
            ))}
          </ul>
        </Alert>
      )}
      {value && formik.values && (

        <div className="accordion mb-3" id="accordion-main">

          <div className="accordion-item" key={"sectionOne"}>
            <h2 className="accordion-header" id={`id_stay_open_heading__01`}>
              <button className="accordion-button d-flex align-items-center" type="button" data-bs-toggle="collapse" data-bs-target={`#id_stay_open_collapse__01`} aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                <i className="fi fi-rr-file-invoice-dollar fs-1 me-2"></i>
                <h2 className='mb-0'>Envío a Notaria</h2>
              </button>
            </h2>
            <div id={`id_stay_open_collapse__01`} className="accordion-collapse collapse" aria-labelledby={`id_stay_open_heading__01`}>
              <div className="accordion-body">
                <div className="container px-0">
                  <div className="row mx-0">
                    <h5 className="px-0">Envio a Notaria</h5>
                    <div className="col-12 col-lg-3 col-xl-2 px-4 px-lg-3 align-self-center text-lg-end">
                      <label className="required fw-bold fs-6 mb-0">Correo destinatario:</label>
                    </div>
                    <div className="col-12 col-lg-9 col-xl-10 mt-2 px-4 px-lg-3">
                      <TagsInput
                        name="emailNotariaList"
                        classNames={{ input: "rti--input form-control form-control-solid w-auto bg-white" }}
                        value={formik.values.emailNotariaList}
                        onChange={(value) => formik.setFieldValue('emailNotariaList', value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item" key={"sectionTwo"}>
            <h2 className="accordion-header" id={`id_stay_open_heading__02`}>
              <button className="accordion-button d-flex align-items-center" type="button" data-bs-toggle="collapse" data-bs-target={`#id_stay_open_collapse__02`} aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                <i className="fi fi-rr-file-invoice-dollar fs-1 me-2"></i>
                <h2 className='mb-0'>Asignación de Firmas</h2>
              </button>
            </h2>
            <div id={`id_stay_open_collapse__02`} className="accordion-collapse collapse" aria-labelledby={`id_stay_open_heading__02`}>
              <div className="accordion-body">
                <div className="container px-0">
                  <div className="row mt-0 mx-0">
                    <h5 className="px-0">Asignación de Firmas</h5>
                    <div className="col-12 col-xl-6 px-4 mt-2">
                      <label className="required fw-bold fs-6 mb-0">Firma Virtual:</label>
                      <div className="d-flex justify-content-between justify-content-lg-start">
                        {formik.values.checksSignedVirtual.map((check, index) => (
                          <Form.Check
                            key={`v-${index}`}
                            id={`v-${index}`}
                            type="checkbox"
                            label={check.firmante.nombre}
                            checked={check.incluido}
                            onChange={(e) =>
                              formik.setFieldValue(
                                `checksSignedVirtual[${index}].incluido`,
                                e.target.checked
                              )
                            }
                            className='me-lg-5 py-3 '
                          />
                        ))}
                      </div>
                    </div>
                    <div className="col-12 col-xl-6 px-4 mt-2">
                      <label className="required fw-bold fs-6 mb-0">Firma Fisica:</label>
                      <div className="d-flex justify-content-between justify-content-lg-start">
                        {formik.values.checksSignedFisical.map((check, index) => (
                          <Form.Check
                            key={`f-${index}`}
                            id={`f-${index}`}
                            type="checkbox"
                            label={check.firmante.nombre}
                            checked={check.incluido}
                            onChange={(e) =>
                              formik.setFieldValue(
                                `checksSignedFisical[${index}].incluido`,
                                e.target.checked
                              )
                            }
                            className='me-lg-5 py-3 '
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item" key={"sectionThree"}>
            <h2 className="accordion-header" id={`id_stay_open_heading__03`}>
              <button className="accordion-button d-flex align-items-center" type="button" data-bs-toggle="collapse" data-bs-target={`#id_stay_open_collapse__03`} aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                <i className="fi fi-rr-file-invoice-dollar fs-1 me-2"></i>
                <h2 className='mb-0'>BCP Provincia</h2>
              </button>
            </h2>
            <div id={`id_stay_open_collapse__03`} className="accordion-collapse collapse" aria-labelledby={`id_stay_open_heading__03`}>
              <div className="accordion-body">
                <div className="container px-0">
                  <div className="row mt-0 mx-0">
                    <h5 className="px-0">BCP Provincia</h5>
                    {formik.values.groupBcp.map((item, index) => (
                      <div key={index} className="col-12  px-4 mt-4">
                        <h6>{item.nombre}</h6>
                        <div className="row px-4 text-lg-end">
                          <div className="col-12 col-lg-3 col-xl-2 mt-3 mt-lg-0 align-self-center">
                            <label className="required fw-bold fs-6 mb-0">Correo destinatario:</label>
                          </div>
                          <div className="col-12 col-lg-9 col-xl-10 mt-2 mt-lg-0 ">
                            <TagsInput
                              classNames={{
                                input: "rti--input form-control form-control-solid w-auto bg-white",
                              }}
                              value={formik.values.groupBcp[index].emails_to_send_carta}
                              onChange={(value) => formik.setFieldValue(`groupBcp[${index}].emails_to_send_carta`, value)}
                            />
                          </div>
                        </div>

                        <div className="row px-4 mt-4 text-lg-end">
                          <div className="col-12 col-lg-3 col-xl-2 mt-3 mt-lg-0 align-self-center">
                            <label className="required fw-bold fs-6 mb-0">Nombre:</label>
                          </div>
                          <div className="col-12 col-lg-9 col-xl-10 mt-2 mt-lg-0 ">
                            <input type="text"
                              className="form-control form-control-solid mb-3 mb-lg-0 w-lg-75 w-xl-50"
                              value={formik.values.groupBcp[index].nombre_to_carta ?? ""}
                              onChange={(e) => formik.setFieldValue(`groupBcp[${index}].nombre_to_carta`, e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        // <div className="container px-0">
        //   <div className="row mx-0">
        //     <h5 className="px-0">Envio a Notaria</h5>
        //     <div className="col-12 col-lg-3 col-xl-2 px-4 px-lg-3 align-self-center text-lg-end">
        //       <label className="required fw-bold fs-6 mb-0">Correo destinatario:</label>
        //     </div>
        //     <div className="col-12 col-lg-9 col-xl-10 mt-2 px-4 px-lg-3">
        //       <TagsInput
        //         name="emailNotariaList"
        //         classNames={{ input: "rti--input form-control form-control-solid w-auto bg-white" }}
        //         beforeAddValidate={validationEmail}
        //         value={formik.values.emailNotariaList}
        //         onChange={(value) => formik.setFieldValue('emailNotariaList', value)}
        //       />
        //     </div>
        //   </div>

        // <div className="row mt-8 mx-0">
        //   <h5 className="px-0">Asignación de Firmas</h5>
        //   <div className="col-12 col-xl-6 px-4 mt-2">
        //     <label className="required fw-bold fs-6 mb-0">Firma Virtual:</label>
        //     <div className="d-flex justify-content-between justify-content-lg-start">
        //       {formik.values.checksSignedVirtual.map((check, index) => (
        //         <Form.Check
        //           key={`v-${index}`}
        //           id={`v-${index}`}
        //           type="checkbox"
        //           label={check.firmante.nombre}
        //           checked={check.incluido}
        //           onChange={(e) =>
        //             formik.setFieldValue(
        //               `checksSignedVirtual[${index}].incluido`,
        //               e.target.checked
        //             )
        //           }
        //           className='me-lg-5 py-3 '
        //         />
        //       ))}
        //     </div>
        //   </div>
        //   <div className="col-12 col-xl-6 px-4 mt-2">
        //     <label className="required fw-bold fs-6 mb-0">Firma Fisica:</label>
        //     <div className="d-flex justify-content-between justify-content-lg-start">
        //       {formik.values.checksSignedFisical.map((check, index) => (
        //         <Form.Check
        //           key={`f-${index}`}
        //           id={`f-${index}`}
        //           type="checkbox"
        //           label={check.firmante.nombre}
        //           checked={check.incluido}
        //           onChange={(e) =>
        //             formik.setFieldValue(
        //               `checksSignedFisical[${index}].incluido`,
        //               e.target.checked
        //             )
        //           }
        //           className='me-lg-5 py-3 '
        //         />
        //       ))}
        //     </div>
        //   </div>
        // </div>

        // <div className="row mt-8 mx-0">
        //   <h5 className="px-0">BCP Provincia</h5>
        //   {formik.values.groupBcp.map((item, index) => (
        //     <div key={index} className="col-12  px-4 mt-4">
        //       <h6>{item.nombre}</h6>
        //       <div className="row px-4 text-lg-end">
        //         <div className="col-12 col-lg-3 col-xl-2 mt-3 mt-lg-0 align-self-center">
        //           <label className="required fw-bold fs-6 mb-0">Correo destinatario:</label>
        //         </div>
        //         <div className="col-12 col-lg-9 col-xl-10 mt-2 mt-lg-0 ">
        //           <TagsInput
        //             classNames={{
        //               input: "rti--input form-control form-control-solid w-auto bg-white",
        //             }}
        //             beforeAddValidate={validationEmail}
        //             value={formik.values.groupBcp[index].emails_to_send_carta}
        //             onChange={(value) => formik.setFieldValue(`groupBcp[${index}].emails_to_send_carta`, value)}
        //           />
        //         </div>
        //       </div>

        //       <div className="row px-4 mt-4 text-lg-end">
        //         <div className="col-12 col-lg-3 col-xl-2 mt-3 mt-lg-0 align-self-center">
        //           <label className="required fw-bold fs-6 mb-0">Nombre:</label>
        //         </div>
        //         <div className="col-12 col-lg-9 col-xl-10 mt-2 mt-lg-0 ">
        //           <input type="text"
        //             className="form-control form-control-solid mb-3 mb-lg-0 w-lg-75 w-xl-50"
        //             value={formik.values.groupBcp[index].nombre_to_carta ?? ""}
        //             onChange={(e) => formik.setFieldValue(`groupBcp[${index}].nombre_to_carta`, e.target.value)}
        //           />
        //         </div>
        //       </div>
        //     </div>
        //   ))}
        // </div>
        // </div>
      )}


    </ConfirmWithLoader>
  )
}